import { lazy, Suspense, useEffect } from 'react';
import { Outlet, Route, useLocation } from 'react-router-dom';

// eslint-disable-next-line no-restricted-imports
import { Layout } from '@/components/Layout/MainLayout';
import { lazyImport } from '@/utils/lazyImport';
import Login from '@/pages/Login';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import RegistEmailPage from '@/pages/RegistEmailPage';
import ConfirmTokenPage from '@/pages/ConfirmTokenPage';
import RegistEmailExpirePage from '@/pages/RegistEmailExpirePage';
import { NotFoundPage } from '@/features/homepage/components/NotFoundPage';
import RegistEmailInformPage from '@/pages/RegistEmailInformPage';
import ResetPasswordInformPage from '@/pages/ResetPasswordInformPage';
import CreatePasswordInformPage from '@/pages/CreatePasswordInformPage';
import CreatePasswordPage from '@/pages/CreatePasswordPage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import ForgotPasswordInformPage from '@/pages/ForgotPasswordInformPage';
import ForgotPasswordPageInvalidUrl from '@/pages/ForgotPasswordPageInvalidUrl';
import ChangePasswordInformPage from '@/pages/ChangePasswordInformPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
const LazyHomePage = lazy(() => import('@/pages/HomePage'));
const LazyChangePasswordPage = lazy(() => import('@/pages/ChangePasswordPage'));
const LazySettingPage = lazy(() => import('@/pages/SettingPage'));
const LazySettingConfirmPage = lazy(() => import('@/pages/SettingPageConfirmPage'));

const { LazyHomeRoutes } = lazyImport(() => import('@/features/homepage'), 'LazyHomeRoutes');

const App = () => {
  const location = useLocation();
  const pathName = `${location.pathname.substring(1)}_dpds`;
  const mapPathNameWithJapanese: Record<string, string> = {
    ['_dpds']: 'ホーム',
    ['delivery-information_dpds']: '納品情報検索',
    ['notification-settings_dpds']: '得意先通知設定',
    ['address-settings_dpds']: '通知先アドレス設定',
  };

  useEffect(() => {
    if (window.performance) {
      if (performance.navigation.type === 1) {
        document.body.style.zoom = '100%';
      }
    }
  }, []);

  return (
    <Layout title={mapPathNameWithJapanese[pathName]} description={pathName}>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            {/* <Spinner size="md" /> */}
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </Layout>
  );
};

export const protectedRoutes = [
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        element: <LazyHomeRoutes />,
      },
      {
        path: 'change-password',
        element: <LazyChangePasswordPage />,
      },
      {
        path: 'setting',
        element: <LazySettingPage />,
      },
      {
        path: 'setting-confirm',
        element: <LazySettingConfirmPage />,
      },
      {
        path: 'privacy-policy',
        element: <PrivacyPolicyPage />,
      },
    ],
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/login/:token',
    element: <Login />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/reset-password-inform',
    element: <ResetPasswordInformPage />,
  },
  {
    path: '/regist-email',
    element: <RegistEmailPage />,
  },
  {
    path: '/regist-email-inform',
    element: <RegistEmailInformPage />,
  },
  {
    path: '/confirm_token/:token',
    element: <ConfirmTokenPage />,
  },
  {
    path: '/token-expired',
    element: <RegistEmailExpirePage />,
  },
  {
    path: 'change-password-inform',
    element: <ChangePasswordInformPage />,
  },
  {
    path: 'create-password',
    element: <CreatePasswordPage />,
  },
  {
    path: '/create-password-inform',
    element: <CreatePasswordInformPage />,
  },
  {
    path: '/forgot-password/:token',
    element: <ForgotPasswordPage />,
  },
  {
    path: '/forgot-password-inform',
    element: <ForgotPasswordInformPage />,
  },
  {
    path: '/forgot-password-expired',
    element: <ForgotPasswordPageInvalidUrl />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];
